<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card" v-else>
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'detail'">
          CHI TIẾT DÒNG HỌ
          <span style="color: #f56c6c">{{ mData.dataForm.ten }}</span>
        </h3>
        <h3 v-if="mData.viewMode === 'update'">
          CẬP NHẬT DÒNG HỌ
          <span style="color: #f56c6c">{{ mData.dataForm.ten }}</span>
        </h3>
        <div
          class="status-dong-ho"
          :class="{
            chua_thanh_toan: mData.dataForm.trang_thai === 'chua_thanh_toan',
            cho_gia_han: mData.dataForm.trang_thai === 'cho_gia_han',
            sap_het_han: mData.dataForm.trang_thai === 'sap_het_han',
            dang_hoat_dong: mData.dataForm.trang_thai === 'dang_hoat_dong',
          }"
        >
          {{ fn_renderStatus(mData.dataForm.trang_thai) }}
        </div>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100px"
        >
          <b-row>
            <b-col lg="7">
              <div class="detail-family__item">
                <div class="detail-family__item--icon">
                  <i
                    class="fa-regular fa-location-dot"
                    title="Địa chỉ dòng họ"
                  ></i>
                </div>
                <span>{{ mData.dia_chi_full }}</span>
              </div>
              <div class="detail-family__item">
                <div class="detail-family__item--icon">
                  <i class="fa-regular fa-users" title="Khoảng đinh"></i>
                </div>
                <span>{{ mData.dataForm.khoangDinh }}</span>
              </div>

              <b-row>
                <b-col md="6">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i
                        class="fa-regular fa-user-check"
                        title="Số thành viên được duyệt"
                      ></i>
                    </div>
                    <span>Số thành viên được duyệt: {{ nodeDuocDuyet }}</span>
                  </div>
                </b-col>
                <b-col md="6">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i
                        class="fa-regular fa-user-clock"
                        title="Số thành viên chờ duyệt"
                      ></i>
                    </div>
                    <span>Số thành viên chờ duyệt: {{ nodeChuaDuyet }}</span>
                  </div>
                </b-col>
              </b-row>
              <div class="detail-family__item">
                <div class="detail-family__item--icon">
                  <i class="fa-regular fa-user-tie" title="Quản lý dòng họ"></i>
                </div>
                <span>Thông tin người quản lý dòng họ</span>
              </div>
              <div class="user-manager">
                <b-row
                  v-for="item in this.mData.arrayNguoiQuanLy"
                  :key="item.id"
                >
                  <b-col sm="12" md="6">
                    <div class="user-manager__item">
                      <i
                        class="fa-regular fa-user-pen"
                        title="Chức vụ người quản lý"
                      ></i>
                      <span>{{ item.role }}</span>
                    </div>
                  </b-col>
                  <b-col sm="12" md="6">
                    <div class="user-manager__item">
                      <i
                        class="fa-regular fa-user-tag"
                        title="Tên người quản lý"
                      ></i>
                      <span>{{ item.name }}</span>
                    </div>
                  </b-col>
                  <b-col sm="12" md="6">
                    <div class="user-manager__item">
                      <i class="fa-regular fa-phone" title="Số điện thoại"></i>
                      <span>{{ item.phone }}</span>
                    </div>
                  </b-col>
                  <b-col sm="12" md="6">
                    <div class="user-manager__item">
                      <i
                        class="fa-regular fa-envelope"
                        title="Địa chỉ email"
                      ></i>
                      <span>{{ item.email }}</span>
                    </div>
                  </b-col>
                </b-row>
              </div>

              <b-row class="detail-family__update">
                <b-col sm="12" md="6">
                  <el-form-item label="Hiệu lực">
                    <el-switch
                      :disabled="
                        mData.viewMode === 'detail' ||
                        (mData.dataForm.hieu_luc &&
                          mData.dataForm.trang_thai === 'dang_hoat_dong') ||
                        (mData.dataForm.hieu_luc &&
                          mData.dataForm.trang_thai === 'sap_het_han')
                      "
                      v-model="mData.dataForm.hieu_luc"
                    >
                    </el-switch>
                  </el-form-item>
                </b-col>
                <b-col sm="12" md="6" v-if="mData.viewMode === 'update'">
                  <el-form-item label="Trạng thái">
                    <el-select
                      v-model="mData.dataForm.trang_thai"
                      placeholder="Chọn trạng thái"
                    >
                      <el-option
                        v-for="item in mData.trangThai"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>

                <b-col sm="12" md="6">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i class="fa-regular fa-link" title="Link hồ sơ"></i>
                    </div>
                    <router-link
                      :to="`/admin/dang-ky-dong-ho/danh-sach-dang-ky-dong-ho/duyet-dang-ky-dong-ho/${this.idDangKyDongHo}`"
                    >
                      Hồ sơ đăng ký dòng họ
                    </router-link>
                  </div>
                </b-col>
                <b-col
                  sm="12"
                  md="6"
                  v-if="
                    mData.viewMode === 'update' &&
                    mData.currentUser === 'SystemAdmin'
                  "
                >
                  <el-form-item label="Đổi đại lý">
                    <el-select
                      v-model="mData.dataForm.dai_ly_id"
                      placeholder="Chọn đại lý"
                      filterable
                    >
                      <el-option
                        v-for="item in mData.list_dai_ly"
                        :key="item.id"
                        :label="item.ten"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col sm="12" md="6">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i
                        class="fa-regular fa-family"
                        title="Danh sách thành viên trong dòng họ"
                      ></i>
                    </div>
                    <router-link
                      :to="`/admin/node-gia-pha/danh-sach-node-gia-pha/${this.$router.currentRoute.params.id}`"
                    >
                      Thành viên dòng họ
                    </router-link>
                  </div>
                </b-col>
                <b-col sm="12" md="6">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i
                        class="fa-regular fa-screen-users"
                        title="Cây gia phả dòng họ"
                      ></i>
                    </div>

                    <router-link
                      :to="`/admin/dong-ho/danh-sach-dong-ho/cay-gia-pha/${this.$router.currentRoute.params.id}`"
                    >
                      Cây gia phả
                    </router-link>
                  </div>
                </b-col>
                <b-col sm="12" md="6" v-if="mData.dataForm.ten_dai_ly">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i class="fa-regular fa-coins" title="Loại dòng tiền"></i>
                    </div>
                    <span>{{ mData.dataForm.loai_dong_tien }}</span>
                  </div>
                </b-col>
                <b-col sm="12" md="6" v-if="mData.dataForm.goi_dich_vu.ten_goi">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i
                        class="fa-regular fa-boxes-packing"
                        title="Gói dịch vụ"
                      ></i>
                    </div>
                    <span>{{ mData.dataForm.goi_dich_vu.ten_goi }}</span>

                    <!-- <el-select
                      v-model="mData.dataForm.goi_dich_vu.goi_dich_vu_id"
                      placeholder="Chọn gói dịch vụ"
                      v-if="mData.viewMode === 'update'"
                    >
                      <el-option
                        v-for="item in mData.list_dich_vu"
                        :key="item.id"
                        :label="item.ten"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select> -->
                  </div>
                </b-col>
                <b-col sm="12">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i
                        class="fa-regular fa-shop"
                        title="Tên đại lý hỗ trợ"
                      ></i>
                    </div>
                    <span style="margin-right: 5px">Đại lý hỗ trợ: </span>
                    <router-link
                      v-if="mData.dataForm.ten_dai_ly"
                      :to="`/admin/dai-ly/chi-tiet/${mData.dataForm.dai_ly_id}`"
                    >
                      {{ mData.dataForm.ten_dai_ly }}
                    </router-link>
                  </div>
                </b-col>
                <b-col sm="12">
                  <div class="detail-family__item">
                    <div class="detail-family__item--icon">
                      <i
                        class="fa-regular fa-shop"
                        title="Tên đại lý khởi tạo"
                      ></i>
                    </div>
                    <span style="margin-right: 5px">Đại lý khởi tạo: </span>
                    <router-link
                      v-if="mData.dataForm.ten_dai_ly_khoi_tao"
                      :to="`/admin/dai-ly/chi-tiet/${mData.dataForm.dai_ly_khoi_tao_id}`"
                    >
                      {{ mData.dataForm.ten_dai_ly_khoi_tao }}
                    </router-link>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="5">
              <GoogleMap
                :positionVulue="mData.positionVulue"
                :height="'337px'"
              />
            </b-col>
          </b-row>
          <div class="detail-family__item">
            <div class="detail-family__item--icon">
              <i class="fa-regular fa-note" title="Thông tin trao đổi"></i>
            </div>
            <span
              @click="showEditorNote = !showEditorNote"
              style="cursor: pointer"
              >Thông tin trao đổi
              <i
                class="fa-regular fa-chevron-down icon-rotate"
                :class="{ rotate180: showEditorNote }"
              ></i>
            </span>
          </div>

          <div
            class="editor-note-container"
            :class="{ height315: showEditorNote }"
          >
            <b-row class="editor-note">
              <b-col sm="12" xl="5">
                <div class="editor-note__list">
                  <el-empty
                    v-if="mData.list_ghi_chu.length === 0"
                    :image-size="100"
                    description="Chưa có ghi chú"
                  ></el-empty>
                  <div v-else class="toastui-editor-contents">
                    <div
                      v-for="item in mData.list_ghi_chu"
                      :key="item.id"
                      class="editor-note__item"
                    >
                      <i class="fa-regular fa-clock"></i>
                      <span>{{
                        `${fn_formatDate(item.thoi_diem_tao, "HH:mm")}`
                      }}</span>
                      <i
                        class="fa-light fa-calendar-days"
                        style="margin-left: 15px"
                      />
                      <span>{{
                        `${fn_formatDate(item.thoi_diem_tao, null)}`
                      }}</span>
                      <i class="fa-regular fa-user" style="margin-left: 15px" />
                      <span>{{ item.account }}</span>
                      <div
                        class="editor-note__content"
                        v-html="markdownToHTML(item.noi_dung)"
                      ></div>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col sm="12" xl="7" class="editor-note__input">
                <div id="editor" ref="editorRef"></div>
                <el-button type="success" v-ladda @click="fn_saveNote()">
                  Tạo ghi chú
                </el-button>
              </b-col>
            </b-row>
          </div>
          <div class="detail-family__item">
            <div class="detail-family__item--icon">
              <i class="fa-regular fa-book-medical" title="Lịch sử dòng họ"></i>
            </div>
            <span @click="fn_showHistoryFamily" style="cursor: pointer"
              >Lịch sử dòng họ
              <i
                class="fa-regular fa-chevron-down icon-rotate"
                :class="{ rotate180: isShowHistoryFamily }"
              ></i
            ></span>
          </div>
          <div
            class="history-family"
            :class="{ height580: isShowHistoryFamily }"
          >
            <NoiDung
              :propDataEditor="mData.dataForm.lich_su"
              :height="'500px'"
              @newData="fn_newData"
            ></NoiDung>
          </div>

          <div class="text-center mt-3">
            <el-button type="primary" @click="fn_back()" v-ladda plain
              >quay lại</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import MethodService from "../../../service/MethodService";
import CategoryModel from "../../../views/admin/GeneralDirector/CategoryModel";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormDongHo";
import Media from "@dongido/vue-viaudio";
import { Circle4 } from "vue-loading-spinner";
import MapComponent from "../../../component/MapComponent.vue";
import GoogleMap from "../../../component/GoogleMap";
import NoiDung from "../../../component/EditorComponent.vue";
import moment from "moment";
import Editor from "@toast-ui/editor";
import { marked } from "marked";

export default {
  components: {
    Media,
    Circle4,
    MapComponent,
    GoogleMap,
    NoiDung,
  },
  data() {
    return {
      editor: null,
      showEditorNote: false,
      isShowHistoryFamily: false,
      aLang: LanguageService.lang,
      hideSlide: false,
      uploadFileName: "",
      loading: true,
      textarea: "",
      newData: "",
      nodeDuocDuyet: 0,
      nodeChuaDuyet: 0,
      url: "", // link chi tiết đăng ký của dòng họ
      idDongHo: "",
      idDangKyDongHo: "",
      maQuocGia: "",

      mData: {
        viewMode: "create",
        currentUser: "",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(CategoryModel.tableRules),
        validForm: MethodService.copyObject(DataForm.validForm),
        trangThai: MethodService.copyObject(DataForm.trangThai),
        total: "",
        dia_chi_full: "",
        positionVulue: [105.75, 21],
        arrayNguoiQuanLy: [],
        list_dai_ly: [],
        list_ghi_chu: [],
        list_dich_vu: [],
      },
    };
  },
  methods: {
    async fn_getAllGoiDichVu() {
      try {
        const response = await mushroom.prd_goi_dich_vu.getAllAsync();
        console.log("Các prd_goi_dich_vu thỏa mãn: %o", response);
        if (response.result) this.mData.list_dich_vu = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    fn_renderStatus(trang_thai) {
      return MethodService.renderStatus(trang_thai);
    },
    fn_showHistoryFamily() {
      this.isShowHistoryFamily = !this.isShowHistoryFamily;
      this.newData = "";
    },
    async fn_getNote() {
      try {
        const response = await mushroom.dong_ho_ghi_chu.getAllAsync(
          {
            filters: ["dong_ho_id=" + this.$router.currentRoute.params.id],
            sort: "-thoi_diem_tao",
          },
          { enabledCache: false }
        );
        if (response.result && response.result.length > 0) {
          let a = response.result.map((item) =>
            mushroom.user.findByIdAsync({
              id: item.nguoi_tao_id,
            })
          );
          await Promise.all(a).then((data) => {
            response.result.forEach((item) => {
              data.forEach((data_item) => {
                if (item.nguoi_tao_id === data_item.result.id)
                  item.account = data_item.result.account || "";
              });
            });
          });

          this.mData.list_ghi_chu = response.result;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_saveNote() {
      const dong_ho_ghi_chu_object = {
        dong_ho_id: this.$router.currentRoute.params.id,
        noi_dung: this.editor.getMarkdown(),
      };
      try {
        const newId = await mushroom.dong_ho_ghi_chu.createAsync(
          dong_ho_ghi_chu_object
        );
        if (newId) {
          window.toastr.success("Thêm mới ghi chú thành công");
          await this.fn_getNote();
          this.editor.setMarkdown("");
        }
      } catch (e) {
        MethodService.showError(e.code);
      } finally {
        MethodService.stopLadda();
      }
    },
    fn_formatDate(date, type) {
      const newDate = new Date(date);
      if (type === "HH:mm") return moment(newDate).format(type);
      return moment(newDate).format("DD/MM/YYYY");
    },
    markdownToHTML(text) {
      return marked(text);
    },
    async fn_getAllDaiLy() {
      try {
        const response = await mushroom.agt_dai_ly.getAllAsync();
        if (response.result) this.mData.list_dai_ly = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // lấy số lượng tối đa
    async fn_getTotal() {
      try {
        const response = await mushroom.dong_ho.listAsync({ limit: 1 });
        this.mData.total = response.meta.total;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initForm() {
      try {
        const response = await mushroom.dong_ho.findByIdAsync({
          id: this.$router.currentRoute.params.id, // required
          fields:
            "id,ten,dia_chi,khoang_dinh,ngay_gio_to,dia_chi_mo_to,nguoi_quan_lys,lich_su,lich_su_file_id,dai_ly_id,dai_ly_khoi_tao_id,hieu_luc,trang_thai,goi_dich_vu,thue_bao_id,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id,thong_tin_tong_hop",
          sort: "-nguoi_quan_lys",
        });
        this.mData.dataForm = response.result;

        // lấy id (không phải dong_ho_id của dòng họ đã đăng ký bên bảng duyệt đăng ký dòng họ)
        const responseIdDongHo = await mushroom.dang_ky.listAsync({
          fields:
            "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet",
          filters: ["dong_ho_id=" + this.$router.currentRoute.params.id],
        });
        localStorage.removeItem("tenDongHo");
        localStorage.setItem("tenDongHo", this.mData.dataForm.ten);
        localStorage.removeItem("nguoiQuanLyDongHoId");
        localStorage.setItem(
          "nguoiQuanLyDongHoId",
          this.mData.dataForm.nguoi_quan_lys[0].nguoi_dung_id
        );
        this.idDangKyDongHo = responseIdDongHo.result[0].id;
        this.url =
          location.origin +
          location.pathname.replace(
            location.pathname,
            "/admin/dang-ky-dong-ho/danh-sach-dang-ky-dong-ho/duyet-dang-ky-dong-ho/"
          ) +
          responseIdDongHo.result[0].id;

        // lấy thông tin người quản lý dòng họ
        this.mData.arrayNguoiQuanLy = [];
        if (response.result.nguoi_quan_lys) {
          response.result.nguoi_quan_lys.forEach(async (item) => {
            const res = await mushroom.nguoi_dung.listAsync({
              fields: "ten,thong_tin_lien_lac",
              filters: ["id=" + item.nguoi_dung_id],
            });
            if (res && res.result.length > 0) {
              this.mData.arrayNguoiQuanLy.push({
                name: res.result[0].ten.ho_ten
                  ? res.result[0].ten.ho_ten
                  : res.result[0].ten.ten,
                phone: MethodService.formatPhone(
                  res.result[0].thong_tin_lien_lac.dien_thoai
                ),
                email: res.result[0].thong_tin_lien_lac.email,
                role: item.quyen == "FamilyAdmin" ? "Trưởng họ" : "Quản trị",
              });
            }
          });
        }

        // lấy thông tin đại lý
        if (response.result.dai_ly_id) {
          const resDaiLy = await mushroom.agt_dai_ly.findByIdAsync({
            id: response.result.dai_ly_id, // required
          });

          if (resDaiLy.result) {
            this.mData.dataForm.ten_dai_ly = resDaiLy.result.ten;
            this.mData.dataForm.loai_dong_tien = resDaiLy.result.loai_dong_tien === "ve_viettoc" ? "Dòng tiền về Việt tộc" : "Dòng tiền về Đại lý";
          }
        }

        // lấy thông tin đại lý
        if (response.result.dai_ly_khoi_tao_id) {
          const resDaiLy = await mushroom.agt_dai_ly.findByIdAsync({
            id: response.result.dai_ly_khoi_tao_id, // required
          });

          if (resDaiLy.result)
            this.mData.dataForm.ten_dai_ly_khoi_tao = resDaiLy.result.ten;
        }

        // lấy tên tỉnh thành
        const resTinhThanh = await mushroom.province.findByIdAsync({
          id: response.result.dia_chi.tinh_id, // required
        });

        // lấy tên quận, huyện
        const resQuanHuyen = await mushroom.district.findByIdAsync({
          id: response.result.dia_chi.huyen_id, // required
        });

        // lấy tên phường, xã
        const resPhuongXa = await mushroom.commune.findByIdAsync({
          id: response.result.dia_chi.xa_id, // required
          fields: "id,disabled,name,code,districtId,index,type,center",
        });

        let diachi = this.mData.dataForm.dia_chi.dia_chi;
        if (resPhuongXa.result)
          diachi +=
            ", " + resPhuongXa.result.type + " " + resPhuongXa.result.name;
        if (resQuanHuyen.result)
          diachi +=
            ", " + resQuanHuyen.result.type + " " + resQuanHuyen.result.name;
        if (resTinhThanh.result)
          diachi +=
            ", " + resTinhThanh.result.type + " " + resTinhThanh.result.name;
        if (response.result.dia_chi.quoc_gia_id) {
          const resQuocGia = await mushroom.quoc_gia.findByIdAsync({
            id: response.result.dia_chi.quoc_gia_id, // required
          });
          diachi += ", " + resQuocGia.result.ten_quoc_gia.vi;
        }
        this.mData.dia_chi_full = diachi;
        this.mData.positionVulue = [];
        this.mData.positionVulue = [
          resPhuongXa.result.center.lng,
          resPhuongXa.result.center.lat,
        ];
        // lấy thông tin khoảng đinh
        if (response.result.khoang_dinh.den) {
          switch (response.result.khoang_dinh.den) {
            case 100:
              response.result.khoangDinh = "Dưới 100 đinh";
              break;
            case 200:
              response.result.khoangDinh = "Từ 100 đinh đến 200 đinh";
              break;
            case 300:
              response.result.khoangDinh = "Từ 200 đinh đến 300 đinh";
              break;
            case 500:
              response.result.khoangDinh = "Từ 300 đinh đến 500 đinh";
              break;
            case 1000:
              response.result.khoangDinh = "Từ 500 đinh đến 1000 đinh";
              break;
            case 3000:
              response.result.khoangDinh = "Từ 1000 đinh đến 3000 đinh";
              break;
            default:
              response.result.khoangDinh = "Dưới 100 đinh";
              break;
          }
        }
        if (
          response.result.khoang_dinh.tu &&
          response.result.khoang_dinh.tu === 3000
        )
          response.result.khoangDinh = "Trên 3000 đinh";

        // lấy số node được duyệt và chưa được duyệt
        const responseNodeDuocDuyet = await mushroom.node_gia_pha.listAsync({
          filters: [
            "dong_ho_id=" + this.$router.currentRoute.params.id,
            "duoc_duyet=true",
          ],
          limit: 1,
        });
        this.nodeDuocDuyet = responseNodeDuocDuyet.meta.total;

        const responseNodeChuaDuyet = await mushroom.node_gia_pha.listAsync({
          filters: [
            "dong_ho_id=" + this.$router.currentRoute.params.id,
            "duoc_duyet=false",
          ],
          limit: 1,
        });
        this.nodeChuaDuyet = responseNodeChuaDuyet.meta.total;

        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // cập nhật dòng họ
    async fn_update() {
      const dong_ho_object = {
        id: this.$router.currentRoute.params.id,
        lich_su: this.newData,
        hieu_luc: this.mData.dataForm.hieu_luc,
        trang_thai: this.mData.dataForm.trang_thai,
      };
      this.mData.currentUser === "SystemAdmin"
        ? (dong_ho_object.dai_ly_id = this.mData.dataForm.dai_ly_id)
        : (dong_ho_object.dai_ly_id = null);

      try {
        const response = await mushroom.dong_ho.partialUpdateAsync(
          dong_ho_object
        );
        if (response.result == this.$router.currentRoute.params.id) {
          window.toastr.success("Cập nhật thông tin dòng họ thành công");
          await this.fn_initForm();
          MethodService.stopLadda();
        } else {
          window.toastr.warning("Dữ liệu không thay đổi");
          MethodService.stopLadda();
        }
      } catch (error) {
        MethodService.stopLadda();
        console.error("Có lỗi: %o", error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },
    fn_newData(data) {
      this.newData = data;
    },
    fn_back() {
      this.$router
        .replace({
          name: "DanhSachDongHo",
        })
        .catch((err) => {});
    },
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_cancel() {
      this.fn_resetForm();
      this.fn_resetDataForm();
      this.$router.push({
        name: "DanhSachDongHo",
      });
    },
    // tải lên file nốt dòng họ
    async fn_uploadFile() {
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("upload-btn-file").files[0], // required
        });
        this.uploadFileName =
          document.getElementById("upload-btn-file").files[0].name;
        this.$forceUpdate();
      } catch (error) {
        console.error(error);
      }
    },

    // xóa file vừa tải lên
    fn_remove() {
      this.uploadFileName = "";
    },
    // reset lại thẻ input khi vừa xóa ảnh/video
    fn_onInputClick(event) {
      event.target.value = "";
    },
    fn_goToNodeGiaPha() {
      this.$router
        .replace({
          name: "DanhSachNodeGiaPha",
        })
        .catch((err) => {});
    },
  },

  async created() {
    JSON.parse(localStorage.getItem("currentUser")).roles.includes(
      "SystemAdmin"
    )
      ? (this.mData.currentUser = "SystemAdmin")
      : (this.mData.currentUser = "");

    setTimeout(() => {
      this.editor = new Editor({
        el: document.querySelector("#editor"),
        height: "300px",
        initialEditType: "wysiwyg",
        previewStyle: "vertical",
        hideModeSwitch: true,
        toolbarItems: [
          ["heading", "bold", "italic", "strike"],
          ["hr"],
          ["ul", "ol", "link", "indent"],
        ],
      });
      this.editor.getMarkdown();
    }, 1000);
    // await this.fn_getAllGoiDichVu();
    await this.fn_getTotal();
    await this.fn_getNote();
    if (this.$router.currentRoute.name == "ChiTietDongHo") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatDongHo") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
      await this.fn_getAllDaiLy();
    }
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.status-dong-ho {
  width: auto;
  margin: unset;
}
::v-deep .flower-spinner {
  background-color: #fff;
}
::v-deep .el-dialog--center {
  height: 75vh;
}
::v-deep .el-dialog__body {
  height: 78%;
}
::v-deep .dialog-import .el-form,
::v-deep .dialog-import .el-form-item,
::v-deep .dialog-import .el-form-item__content,
::v-deep .dialog-import .el-input--small,
::v-deep .el-textarea__inner {
  height: 100%;
}
::v-deep .dialog-import textarea {
  height: 100%;
  width: 100%;
  border: 1px solid #dcdfe6;
  padding: 10px;
  border-radius: 5px;
}

::v-deep .vue-map-container .vue-map {
  border-radius: 5px;
}
.btn-link {
  border: none;
  color: rgb(64, 158, 255);
  padding: 0;
  &:hover {
    background-color: #fff;
  }
}
// fix bản đồ lệch nút checkbox
::v-deep li span > img {
  transform: translateY(-2px);
}
.role-admin {
  font-size: 15px;
  font-weight: bold;
}
.detail-family {
  &__item {
    display: flex;
    margin-bottom: 15px;
  }
  &__item .icon-rotate {
    transition: 0.2s;
    margin-left: 7px;
  }
  &__item--icon {
    width: 30px;
    text-align: center;
    i {
      margin-right: 10px;
    }
  }
  &__update {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
.user-manager {
  border: thin dashed #dcdcdc;
  border-radius: 5px;
  padding: 0 10px;
  margin-left: 13px;
  margin-bottom: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 171px;
  &__item {
    i {
      margin-right: 10px;
    }
  }
  .row {
    padding: 5px 0;
    &:hover {
      background-color: #f5f7fa;
    }
  }
  .row:nth-child(even) {
    background-color: #fafafa;
  }
  .row:last-child {
    padding-bottom: 0;
    // border-bottom: unset;
  }
}
// .change-agent {
//   display: flex;
//   justify-content: space-between;
// }
// ::v-deep .change-agent .el-form-item__content {
//   width: 100%;
// }
// ::v-deep .change-agent .el-form-item__label {
//   min-width: 100px;
// }
.editor-note-container,
.history-family {
  height: 0;
  transition: 0.2s;
  overflow: hidden;
}

.height580 {
  height: 580px;
}
.editor-note {
  &__list {
    border: thin solid #dcdcdc;
    border-radius: 5px;
    padding: 10px;
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    i {
      color: #e6a23c;
      padding-right: 7px;
      font-style: unset;
    }
    span {
      color: #969696;
      font-size: 14px;
    }
  }
  &__item {
    margin-bottom: 10px;
  }
  &__content {
    margin-left: 23px;
  }

  &__input {
    position: relative;
    #editor {
      text-align: left;
    }
    button {
      position: absolute;
      top: 7px;
      right: 21px;
    }
  }
}
.height315 {
  height: auto; // theo độ cao của editor
}
@media (min-width: 1300px) {
  .height315 {
    height: 315px;
  }
}
</style>
